import type { UserNotificationResponseDto } from "../types/types";

export const resolveNotificationPath = (notification: UserNotificationResponseDto) => {
  if (notification.ctaPath) {
    return notification.ctaPath;
  }

  switch (notification.type) {
    case "GIG_REQUEST_NEEDS_REVIEW":
      return "/adult/gigs?view=NEEDS_APPROVAL";
    case "SCHEDULE_PROPOSAL_CONFIRMED":
      return "/adult/gigs?view=NEEDS_APPROVAL";
    case "SCHEDULE_PROPOSAL_RECEIVED":
      return "/teen/gigs";
    case "GIG_SELECTED":
      return "/teen/scheduled-gigs";
    case "GIG_REQUEST_REJECTED":
      return "/teen/gigs";
    case "GIG_REQUEST_UPDATE_ACKNOWLEDGMENT_REQUIRED":
    case "GIG_REQUEST_RESCHEDULE_REQUIRED":
      return "/teen/gigs";
    case "REVIEW_RECEIVED":
      return "/notifications";
    default:
      return "/notifications";
  }
};
